<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="editRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top" v-if="isPermissionDelete()">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>
        <vs-popup class="holamundo"  title="Chi tiết nhân sự" :active.sync="popupDetailsEmployee" v-if="popupDetailsEmployee" id="details-employee">
            <EmployeeInformation :employeeId="employeeId"></EmployeeInformation>
        </vs-popup>
    </div>
</template>

<script>
import {isAPI} from "../../../../store/permission";
import {constAPI} from "../../../../store/constant";
import EmployeeInformation from "../EmployeeInformation";

export default {
    name: 'CellRendererActions',
    components: {
        EmployeeInformation,
    },
    data() {
        return {
            popupDetailsEmployee: false,
            employeeId: null,
        }
    },
    methods: {
        isPermissionDelete() {
            return isAPI(this, constAPI.employee_delete);
        },
        editRecord() {
            this.employeeId = this.params.data.id;
            this.popupDetailsEmployee = true;
            // this.$router.push(`/user/edit-employee?branch_id=${this.params.data.organizationBranchId}&id=${this.params.data.employeeId}`).catch(() => {
            // })
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá nhân viên "${this.params.data.fullName}" không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            this.$crm.post('/employee/delete/' + this.params.data.employeeId).then(() => {
                this.$vs.loading.close();
                this.showDeleteSuccess();
                this.$store.commit('UPDATE_EMPLOYEE', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xoá thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    },

    mounted() {
        this.$eventBus.$on('update-employee-success', () => {
            this.popupDetailsEmployee = false;
            this.$store.commit('UPDATE_EMPLOYEE', true);
        })
    }
}
</script>

<style lang="scss">
#details-employee {
    .vs-popup {
        width: 1400px !important;
    }
}
</style>

